import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import your language resources
import en from './locales/en';
import hr from './locales/hr';
import sl from './locales/sl';

export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en', 'sl', 'hr'] as const;
// Define namespaces from your files
export const namespaces = ['home', 'settings'];

export const resources = {
  en,
  sl,
  hr,
} as const; // 'as const' helps with type inference

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,

    // Define your namespaces
    ns: namespaces,
    defaultNS: 'home', // Set a default namespace

    // Debugging
    debug: import.meta.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
